
import * as React from "react";
import { Capacitor } from '@capacitor/core';

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    // Function to check if viewport is mobile width or if running on native platform
    const checkIfMobile = () => {
      const isNativeApp = Capacitor.isNativePlatform();
      const isSmallViewport = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(isNativeApp || isSmallViewport);
    };
    
    // Set initial state
    checkIfMobile();
    
    // Add event listener for resize (only relevant for web)
    if (!Capacitor.isNativePlatform()) {
      window.addEventListener('resize', checkIfMobile);
    }
    
    // Clean up
    return () => {
      if (!Capacitor.isNativePlatform()) {
        window.removeEventListener('resize', checkIfMobile);
      }
    };
  }, []);

  return isMobile;
}
